<template lang="pug">
    div.main-container(:style="{backgroundSize:'cover', backgroundImage:'url(' + require('@/assets/img2/insigne-bg-stroke-grey.png') + ')'} ")
        div.overlay
        div.main-content(id="content")
            div.layout-px-spacing
                div.page-header
                    div.page-title
                        h3  {{ $t('activateexam.activationexams') }}
                    
                    div.text-center.mx-auto
                    
                    div
                        nav.breadcrumb-one(aria-label="breadcrumb")
                            ol.breadcrumb
                              li.breadcrumb-item
                                router-link(to="/student/studenthome") {{ $t('activateexam.studentdashboard') }}
                              li.breadcrumb-item.ctive(aria-current="page") {{ $t('activateexam.activatexam') }}
                div.row.mt-5.pb-5
                    div.col-lg-6.col-md-6.mx-auto.layout-spacing
                        div.widget.box.box-shadow
                            div.widget-header
                                div.row.mt-4
                                    div.col-xl-12.col-md-12.col-sm-12.col-12.text-center
                                        h3 {{ $t('activateexam.actianexa') }}
                                div.widget-content.widget-content-area
                                    div.col-md-12
                                        div.form-group
                                            label(for="") {{ $t('activateexam.capturecode') }}
                                            input.form-control(type="text" id="" :placeholder="$t('activateexam.code')" v-model="sCode" )
                                  
                                        div.form-group.mb-4
                                            label(for="") {{ $t('activateexam.examsavailable') }}
                                            select.form-control(id="" v-model="idExam")
                                                option(value="0" selected) {{ $t('activateexam.selectexa') }}
                                                option(:value = "exam.idExam" v-for="exam in examsList") {{ exam.sExamName }}

                                        
                                        a.btn.btn-primary(@click="activate") {{ $t('activateexam.activate') }} 
                                            i
                                                svg.feather.feather-power(xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                                                    path(d="M18.36 6.64a9 9 0 1 1-12.73 0")
                                                    line(x1="12" y1="2" x2="12" y2="12")


</template>
<script>
/* eslint-disable */
export default {
    name: 'ActivateExam',
    data() {
        return {
            examsList: [],
            idExam: 0,
            sCode: ''
        }
    },
    methods: {
        async getExams() {
            await axios.get(apiURL + 'Student/getExamsAvailables', { headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.userToken
            } })
            .then( (response) => {
                this.examsList = response.data.examList
            } )
            .catch( (error)  => {
                console.log("error")
            } )            
        },
        async activate() {
            this.openLoading(this.$t('msg.activecode') );
            //this.openLoading('Activando Código ...');
            var model= {
                idExam: this.idExam,
                sCode: this.sCode,
                idPerson: localStorage.CertIdP
            }

            await axios.post(apiURL + 'Student/activateCode', model, { headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.userToken
            } })
            .then( (response) => {
                Swal.close();
                if(response.data.bIsCorrect == false){
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: response.data.sErrors[0],
                        footer: ''
                    })
                    return
                }
                //this.$parent.getMyExams();
                Swal.fire('Datos Guardados correctamente')
                router.push('/student/studenthome')
            } )
            .catch( (error) => {
                Swal.close();
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error,
                    footer: ''
                })
            } )            
        }
        

    },
    mounted() {
        this.checkPermisions(this.$router.currentRoute.path)
        this.getExams()
    }
        

}
</script>                                                              